import { Checkbox } from "components/DesignSystem/Checkbox/Checkbox";
import ToolTip from "components/design/toolTip";
import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import { Tag } from "components/DesignSystem/Tag/Tag";
import { useAuth } from "hooks/useAuth";

export const ExportOptions = ({
  onLocalDownload,
  onMailExport,
  onSaveInInkleDocs,
  recommendedOptionText,
  showDraftOption,
  isDraft,
  onDraftChange,
}: {
  onLocalDownload: () => void;
  onMailExport: () => void;
  onSaveInInkleDocs?: () => void;
  recommendedOptionText?: string;
  showDraftOption?: boolean;
  isDraft?: boolean;
  onDraftChange?: (checked: boolean) => void;
}) => {
  const { email } = useAuth();

  return (
    <>
      <Dropdown.Item onSelect={onMailExport}>
        <div>
          <div className="t-flex t-justify-between t-gap-2">
            <div>Export to mail</div>
            {recommendedOptionText && (
              <ToolTip
                text={<div className="t-w-44">{recommendedOptionText}</div>}
              >
                <div>
                  <Tag tagType="gray" rounded icon={false} size="small">
                    Recommended
                  </Tag>
                </div>
              </ToolTip>
            )}
          </div>

          <div className="t-text-body-sm t-text-text-30">
            Export will be mailed to <br /> {email} once done
          </div>
        </div>
      </Dropdown.Item>
      <Dropdown.Item onSelect={onLocalDownload}>
        <div>
          Download locally
          <div className="t-text-body-sm t-text-text-30">
            This may take upto a minute
          </div>
        </div>
      </Dropdown.Item>
      {onSaveInInkleDocs && (
        <Dropdown.Item onSelect={onSaveInInkleDocs}>
          Save in Inkle Documents
        </Dropdown.Item>
      )}
      {showDraftOption && (
        <>
          <Dropdown.Separator />
          <Dropdown.Item
            onSelect={(e) => {
              e.preventDefault();
              onDraftChange?.(!isDraft);
            }}
          >
            <div className="t-flex t-items-center t-gap-2">
              <Checkbox
                checked={isDraft}
                onChange={() => undefined}
                name="add-draft-watermark"
              />
              <span>Add draft watermark</span>
            </div>
          </Dropdown.Item>
        </>
      )}
    </>
  );
};
